import React, { useEffect } from 'react';
import { useTranslation } from '../hooks/useTranslation';

export default function SEO() {
    const { t, language } = useTranslation();

    useEffect(() => {
        // Update Title
        const title = t('metadata.title');
        document.title = title;

        // Update HTML lang attribute
        document.documentElement.lang = language === 'pt' ? 'pt-BR' : 'en-US';

        // Helper function to update meta tags
        const updateMetaTag = (name, content, attr = 'name') => {
            let element = document.querySelector(`meta[${attr}="${name}"]`);
            if (!element) {
                element = document.createElement('meta');
                element.setAttribute(attr, name);
                document.head.appendChild(element);
            }
            element.setAttribute('content', content);
        };

        // Description
        const description = t('metadata.description');
        updateMetaTag('description', description);

        // ogImage logic: use marnettech.png (can be localized if needed in the future)
        const ogImage = t('metadata.ogImage');
        const fullImageUrl = `${window.location.origin}/${ogImage}`;

        // Open Graph
        updateMetaTag('og:title', title, 'property');
        updateMetaTag('og:description', description, 'property');
        updateMetaTag('og:image', fullImageUrl, 'property');
        updateMetaTag('og:url', window.location.href, 'property');

        // Twitter
        updateMetaTag('twitter:title', title, 'name');
        updateMetaTag('twitter:description', description, 'name');
        updateMetaTag('twitter:image', fullImageUrl, 'name');

    }, [t, language]);

    return null; // This component doesn't render anything
}
